<template>
  <div style="display: none"></div>
</template>

<script>
import axios from 'axios'
import gaspump from '~/lib/gaspump'
import { DateTime } from 'luxon'

export default defineNuxtComponent({
  mixins: [gaspump],
  data () {
    return {
      transInterval: null
    }
  },
  computed: {
    myComponentId() {
      return 'gaspumplistener'
    }
  },
  methods: {
    handleStatusUpdate(shouldStore) { // This method is used to handle status updates: changing fuel types and finishing up fillings. shouldStore parameter determines if we should store fillings (=old johku printer)
      let statuses = this.status.pumpStatus.pStat
      for (let i = 0; i < statuses.length; i++) {
        let status = parseInt(statuses[i], 10)
        let prevStatus = parseInt(this.prevStatuses[i], 10)
        if (status === 3 && prevStatus !== status) { // x to 3 => Started Filling
          this.fuelTypes[i] = this.status.pumpStatus.nameGas[i]
          this.fuelPrices[i] = this.status.pumpStatus.prices[i].price[this.status.pumpStatus.cNozzle[i]]
        }
        if (shouldStore && this.prevFlagFilling) {
          if (parseInt(this.getFillingStatus(this.prevFlagFilling, i)) && !parseInt(this.getFillingStatus(this.status.pumpStatus.flagFilling, i))) {
            this.storeFilling(i)
          }
        }
      }
      this.prevStatuses = statuses
      this.prevFlagFilling = this.status.pumpStatus.flagFilling
      // This whole "let's store the last valid litre and amount" is because Infodata's pump sometimes spits out zero values for no fucking reason
      let litres = this.status.pumpStatus.litre
      for (let i = 0; i < litres.length; i++) {
        let litre = parseInt(litres[i])
        if (litre) {
          this.prevLitres[i] = litre
        }
      }
      let amounts = this.status.pumpStatus.amount
      for (let i = 0; i < amounts.length; i++) {
        let amount = parseInt(amounts[i])
        if (amount) {
          this.prevAmounts[i] = amount
        }
      }
    },
    async storeFilling(i) {
      let data = {
        date: new Date(),
        pumpIndex: i,
        gasType: this.fuelTypes[i],
        price: this.fuelPrices[i] / 1000,
        litres: this.status.pumpStatus.litre[i] / 100,
        amount: this.status.pumpStatus.amount[i] / 100,
        source: this.getSource(parseInt(this.status.pumpStatus.flagFilling, 10), i),
        status: 0,
        pos: this.pos
      }
      if (!data.amount || !data.litres) {
        return
      }
      let response = await axios.post(this.baseDomain + this.shopId + '/gas.json?client=' + this.clientid, data)
      data.id = response.data
      this.$socket.emit('message', {
        type: 'gasPumpTransaction',
        data: data,
        shopId: this.$store.state.shopId,
        pos: this.pos,
        clientid: this.clientid,
        tabid: this.tabid
      })
      // this.EventBus.$emit('gasPumpTransaction', data)
    }
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['gasPumpStatus'] = (message) => {
        if (this.shopId == message.shopId) {
          this.status = message.data
          this.handleStatusUpdate(message.local ? false : true)
          return
        }
      }
      events['gasPumpTransaction'] = (message) => {
        if (this.shopId === message.shopId && message.source === 'johkuprinter') {
          const d = message.data
          let data = {
            date: DateTime.fromSeconds(Number(d.ts)).toJSDate(),
            frame: d.frame,
            pumpIndex: d.pumpIndex,
            gasType: d.gasType,
            price: d.price, 
            litres: d.litres,
            amount: d.amount,
            source: d.source,
            status: d.status,
            pos: this.pos
          }
          if (!data.amount || !data.litres) {
            return
          }
          axios.post(this.baseDomain + this.shopId + '/gas.json?client=' + this.clientid, data)
        }
      }
      if (this.transInterval) {
        clearInterval(this.transInterval)
      }
      this.transInterval = setInterval(() => {
        axios.patch(this.baseDomain + this.shopId + '/gas.json?client=' + this.clientid, { action: 'requestGasPumpTransactions' })
      }, 60000) // Request transactions every minute
      this.events = events
    }
    this.enableEventBus()
  },
  beforeUnmount () {
    if (this.transInterval) {
      clearInterval(this.transInterval)
    }
  }
})
</script>